import { render, staticRenderFns } from "./OpenBtn.vue?vue&type=template&id=72889e56&"
import script from "./OpenBtn.vue?vue&type=script&lang=js&"
export * from "./OpenBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports